module.exports = __webpack_public_path__ + "img/payments.ba01284e.svg";